/**
 * MyFaceDr Region Switcher Utilities
 * Helper functions for manual region/language switching
 */

(function(window) {
  'use strict';

  const RegionSwitcher = {
    /**
     * Build store URL with proper path and language handling
     */
    buildStoreUrl(storeUrl, options = {}) {
      const { currentPath, currentLang, euDomain = 'eu.myfacedr.com' } = options;

      // Remove locale prefixes like /en-gb
      const cleanPath = currentPath.replace(/^\/[a-z]{2}-[a-z]{2}/, '');

      // Handle EU store with language prefix
      if (storeUrl.includes(euDomain) && currentLang !== 'en') {
        return `${storeUrl}/${currentLang}${cleanPath}`;
      }

      return `${storeUrl}${cleanPath}`;
    },

    /**
     * Perform region switch with manual location parameter
     */
    switchRegion(storeUrl, options = {}) {
      const finalUrl = this.buildStoreUrl(storeUrl, options);
      const urlWithParam = window.MyFaceDrGeoRedirect?.addManualLocationParam(finalUrl) || finalUrl;
      window.location.href = urlWithParam;
    },

    /**
     * Handle language switching within same store
     */
    switchLanguage(langCode, currentPath) {
      const pathSegments = currentPath.split('/').filter(Boolean);

      if (langCode === 'en') {
        // Remove language prefix for English
        if (pathSegments[0]?.length === 2) {
          pathSegments.shift();
        }
      } else {
        // Add or replace language prefix
        if (pathSegments[0]?.length === 2) {
          pathSegments[0] = langCode;
        } else {
          pathSegments.unshift(langCode);
        }
      }

      const newPath = pathSegments.length > 0 ? '/' + pathSegments.join('/') : '/';
      window.location.href = newPath + window.location.search;
    }
  };

  // Expose to global scope
  window.MyFaceDrRegionSwitcher = RegionSwitcher;

})(window);
